import React, { useEffect, useState } from 'react';
import api from '@/api/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function BillingView() {
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    api.get('/billing/plan-status').then(({ data }) => {
      if (data.success) setPlan(data.data);
    }).catch(() => toast.error('Erro ao carregar faturação'));
  }, []);

  const toggle = async (feature) => {
    try {
      await api.post(`/billing/toggle-${feature}`);
      const { data } = await api.get('/billing/plan-status');
      if (data.success) setPlan(data.data);
      toast.success(`${feature} atualizado`);
    } catch (err) {
      toast.error('Erro ao atualizar');
    }
  };

  const upgrades = [
    { key: 'whatsapp_enabled', label: 'WhatsApp', price: '€0.50/motorista' },
    { key: 'auto_import_enabled', label: 'Auto-Import', price: '€0.50/motorista' },
    { key: 'fiscal_engine_enabled', label: 'Motor Fiscal', price: '€30/€60/€120' },
    { key: 'compliance_enabled', label: 'Compliance', price: '€30/€60/€120' },
    { key: 'pwa_enabled', label: 'PWA Motorista', price: '€0.50/motorista' },
    { key: 'telematics_enabled', label: 'Telematics', price: '€5/viatura' },
    { key: 'white_label_enabled', label: 'White-Label', price: '€50/€100' },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold tracking-tight">Faturação</h1>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <MetricCard title="Total estimado" value={plan ? `€${plan.grand_total?.toFixed(2) || 0}` : '-'} />
        <MetricCard title="Motoristas ativos" value={plan?.active_drivers ?? '-'} />
        <MetricCard title="Base" value={plan ? `€${plan.base_revenue?.toFixed(2) || 0}` : '-'} />
        <MetricCard title="Extra SEPA" value={plan ? `€${plan.sepa_fee?.toFixed(2) || 0}` : '-'} />
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {upgrades.map((u) => (
          <Card key={u.key}>
            <CardHeader className="pb-2">
              <CardTitle className="text-base">{u.label}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-3">{u.price}</p>
              <Button size="sm" variant={plan?.[u.key] ? 'default' : 'outline'} onClick={() => toggle(u.key)}>
                {plan?.[u.key] ? 'Ativo' : 'Ativar'}
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}

function MetricCard({ title, value }) {
  return (
    <Card>
      <CardHeader className="pb-2"><CardTitle className="text-sm text-muted-foreground">{title}</CardTitle></CardHeader>
      <CardContent><div className="text-2xl font-bold">{value}</div></CardContent>
    </Card>
  );
}
